import styles from "./table-interactive.module.css";

export const expandableIcon: Record<string, string> = {
  open: styles["body-column-expandable-button-state-open"],
  close: "",
};

export const generateClassesExpandableIcon = (
  isOpen: boolean,
  className?: string
) => {
  return `${styles["body-column-expandable-button"]} ${
    expandableIcon[isOpen ? "open" : "close"]
  } ${className || ""}`;
};

export const expandableRow: Record<string, string> = {
  open: styles["body-column-expandable-row-state-open"],
  close: "",
};

export const generateClassesExpandableRow = (
  isOpen: boolean,
  className?: string
) => {
  return `${className || ""} ${styles["body-column-expandable-row"]} ${
    expandableRow[isOpen ? "open" : "close"]
  }`;
};

export const generateClassesBodyColumn = (isActive: boolean) => {
  return `${styles.sortby} ${isActive ? styles["sortby-active"] : ""}`;
};

export const generateClassesSortColumn = (isSelected: boolean) => {
  return `${styles["sort-menu-item"]} ${isSelected ? styles.selected : ""}`;
};

const statesTableControl: Record<"without-border" | "with-border", string> = {
  "without-border": "",
  "with-border": styles["table-control-with-border"],
};

const statesLockTableControl: Record<"lock" | "unlock", string> = {
  lock: styles["table-control-locked"],
  unlock: styles["table-control-unlocked"],
};

export const generateClassesOfTableControl = (
  isShowBorder: boolean,
  isLocked: boolean
) => {
  return `${styles["table-control"]} ${statesTableControl[isShowBorder ? "with-border" : "without-border"]}
    ${statesLockTableControl[isLocked ? "lock" : "unlock"]}
  `;
};
